import React from "react";
import { Box, Typography, Button, Modal } from "@mui/material";
import { RefreshCw, Lock, AlertCircle } from "lucide-react";
import {
  modalStyles,
  backdropStyles,
  modalContentStyles,
  iconContainerStyles,
  messageContainerStyles,
  messageTextStyles,
  reloadButtonStyles,
} from "./styles";
import { clearMultiTabSessionState } from "../../utils/multiTabDetection";
import { getUserIdFromToken } from "../../utils/authToken";
import useUserStore from "../../stores/userStore";

interface ConnectionErrorModalProps {
  open: boolean;
  message: string;
  onClose: () => void;
}

export const ConnectionErrorModal: React.FC<ConnectionErrorModalProps> = ({
  open,
  message,
  onClose,
}) => {
  const handleReload = () => {
    const userId =
      useUserStore.getState().user?.id || getUserIdFromToken() || undefined;
    clearMultiTabSessionState(userId);
    window.location.reload();
  };

  const handleClose = (
    event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {};

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={modalStyles}
      disableEscapeKeyDown
      disableAutoFocus
    >
      <Box sx={backdropStyles}>
        <Box sx={modalContentStyles}>
          <Box sx={iconContainerStyles}>
            <AlertCircle size={32} color="#FFFFFF" strokeWidth={2.5} />
          </Box>

          <Box sx={messageContainerStyles}>
            <Lock size={18} color="#D97706" strokeWidth={2.5} />
            <Typography variant="body1" sx={messageTextStyles}>
              {message}
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={<RefreshCw size={18} />}
            onClick={handleReload}
            sx={reloadButtonStyles}
          >
            Reload the Page
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
